<template>
  <div class="page-section light-blue-section">
    <h1
      class="info-title red padding-top-10"
    >
      Your <b>spending categories</b>
    </h1>
    <p class="section-subtitle">
      Here are the categories you spent most on in the last 5 months
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your spending categories.
      <b @click="handleConnectAccountsClick">connect an active <br> account</b>
      to get the full picture
    </div>
    <div
      v-for="(category, index) in monthlyCategoryAverages.slice(0, 7)"
      :key="index"
      class="category-item"
      :class="{ 'disabled': isDataMissing }"
    >
      <span class="category-label">{{ category.categoryLabel }}</span>
      <span class="category-amount">£{{ numberToHumanReadable(Math.round(category.averageSpending)) }}</span>
    </div>
  </div>
</template>

<script setup>
import { numberToHumanReadable } from '../../../utils/miscUtils';

const props = defineProps({
  monthlyCategoryAverages: {
    type: Array,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
@import '../../../scss/riseup-vars';

.light-blue-section {
  background-color: #EEF2F8;
  color: #002579;
}

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.red {
  color: #F14241;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.connect-another-subtitle {
  font-size: 14px;
  font-family: 'SalaryFinance';
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: #FFDC73;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.category-item {
  background-color: white;
  border-radius: 20px;
  width: 90%;
  padding: 30px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 16px 46.4px 0px #0000001C;

  &.disabled {
    background-color: #F1F5FA !important;
    box-shadow: 0px 16px 46.4px 0px #00000010 !important;
    .category-label,
    .category-amount {
      color: #B0B0B0 !important;
    }
  }
}

.category-label {
  font-size: 18px;
  color: #002579;
  font-family: 'SalaryFinance';
}

.category-amount {
  font-size: 24px;
  font-weight: bold;
  color: #002579;
}

.padding-top-10 {
  padding-top: 10px;
}
</style>
